import React from 'react'
import { Steps } from 'antd';
import Avatar from 'components/Avatar'
import CustomTag from 'components/CustomTag'
import Flex from 'components/Flex'
import AwardsIconWork from 'components/icons/AwardsIconWork'
import ApartmentIcon from 'components/icons/ApartmentIcon'
import FileReaderVisibleOnly from 'components/Uploader/FileReaderVisibleOnly'
import {
  BoldTextDate,
  EditorContent,
  GreyText,
  NameAdd1,
  RewardTite,
  SecondaryHeading,
  SecondaryHeadingNew,
  StyledP,
  SubFLex,
  TextLight1,
  VerticalDivider,
} from './style'
import moment from 'moment'
import { COLORS } from 'theme'
import { ExclamationCircleFilled } from '@ant-design/icons'
import styled from 'styled-components'

const PendingIcon = styled(ExclamationCircleFilled)`
  color: #eb5d60;
  font-size: 16px;
  margin-left: 8px;
`

const WorkExpSection = ({ promotionData, pendingData }) => {
console.log(pendingData,"pendingData")
  const hasFieldPending = (item, fieldName) => {
    return item?._pendingFields && item._pendingFields[fieldName] !== undefined
  }

  const rawWorkExp = Array.isArray(promotionData?.resume?.workExperience) ? promotionData.resume.workExperience : []

  // Convert flat array to grouped array format if needed
  const approvedWorkExp = rawWorkExp.map(item => {
    // If item is already an array (grouped), return as is
    if (Array.isArray(item)) {
      return item
    }
    // If item is a single object, wrap it in an array
    return [item]
  })

  const pendingWorkExp = pendingData?.resume?.workExperience || []

  // Apply pending changes to approved work experience groups
  const mergedWorkExpGroups = approvedWorkExp.map(group => {
    if (Array.isArray(group)) {
      return group.map(item => {
        const pendingChange = pendingWorkExp.find(
          pending => pending.id === item.id || pending._tempId === item.id || pending._itemId === item.id
        )
        if (pendingChange && pendingChange._pendingFields) {
          return {
            ...item,
            ...pendingChange,
            _requestId: Object.values(pendingChange._pendingFields)[0]?._requestId,
            _status: Object.values(pendingChange._pendingFields)[0]?._status,
            _hasPendingChanges: true
          }
        }
        return item
      })
    }
    return group
  })

  // Handle new pending work experience items
  const newPendingWorkExp = pendingWorkExp.filter(
    pending => pending._isNew || !rawWorkExp.find(item => item.id === pending.id || item.id === pending._itemId || item.id === pending._tempId)
  )

  newPendingWorkExp.forEach(newWork => {
    mergedWorkExpGroups.push([newWork])
  })

  const allWorkExpGroups = mergedWorkExpGroups

  const countRichTextCharacters = richText => {
    // Remove HTML tags using a regular expression
    const plainText = richText?.replace(/<[^>]*>/g, '')?.replace(/&nbsp;/g, ' ');

    // Count the characters in the plain text
    const characterCount = plainText?.length || 0; // Set to 0 if undefined

    return characterCount
  };


  const DateDiff = (start, end) => {
    const StartSplit = start?.split('/')
    const EndSplit = end ? end?.split('/') : new Date()
    const startDate = new Date(StartSplit[1], StartSplit[0], 1)
    const endDate = end ? new Date(EndSplit[1], EndSplit[0], 1) : new Date()
    const diffInMonths =
      (endDate.getFullYear() - startDate.getFullYear()) * 12 +
      (endDate.getMonth() - startDate.getMonth()) + 1

    if (diffInMonths >= 12) {
      const years = Math.floor(diffInMonths / 12)
      const months = diffInMonths % 12
      return `${years === 1 ? years + ' year' : years > 1 ? years + ' years' : ''} ${months === 1 ? months + ' month' : months > 1 ? months + ' months' : ''}`;
    } else {
      return `${diffInMonths === 1 ? diffInMonths + ' month' : diffInMonths > 1 ? diffInMonths + ' months' : ''}`;
    }
  }

  const DateDiffArray = (positions) => {
    const calculateDurationInMonths = (start, end) => {
      const StartSplit = start?.split('/');
      const EndSplit = end ? end?.split('/') : new Date();
      const startDate = new Date(StartSplit[1], StartSplit[0], 1);
      const endDate = end ? new Date(EndSplit[1], EndSplit[0], 1) : new Date();
      return (
        (endDate.getFullYear() - startDate.getFullYear()) * 12 +
        (endDate.getMonth() - startDate.getMonth()) + 1
      );
    };

    const totalDurationInMonths = positions.reduce((total, position) => {
      const end = position.isCurrentlyWorking ? undefined : position.ended_in;
      return total + calculateDurationInMonths(position.started_in, end);
    }, 0);

    if (totalDurationInMonths >= 12) {
      const years = Math.floor(totalDurationInMonths / 12);
      const months = totalDurationInMonths % 12;
      return `${years === 1 ? years + ' year' : years > 1 ? years + ' years' : ''} ${months === 1 ? months + ' month' : months > 1 ? months + ' months' : ''}`;
    } else {
      return `${totalDurationInMonths === 1 ? totalDurationInMonths + ' month' : totalDurationInMonths > 1 ? totalDurationInMonths + ' months' : ''}`;
    }
  };



  return (
    <>
      <style>
        {`
        .ant-steps-vertical > .ant-steps-item > .ant-steps-item-container > .ant-steps-item-tail::after {
          width: 1.34px;  // Set the width of the progress line
          height: 100%;
          background-color: #D9D9D9;  // Set the color of the progress line
        }
      `}
      </style>

      <SubFLex column gap="25px">
        {allWorkExpGroups?.map((experienceGroup, groupIndex) => (
          <>
            {experienceGroup?.length > 1 ? (

              <SubFLex gap="12px">
                <div>
                  <Avatar
                    background="none"
                    src={''}
                    size={48}
                    icon={<ApartmentIcon />}
                    boxShadow={true}
                    padding="5px"
                    shape="square"
                  />
                </div>
                <SubFLex column style={{ width: '90%' }}>
                  <SecondaryHeadingNew fontWeight="600" style={{ wordBreak: 'break-word', overflowWrap: 'anywhere', display: 'flex', alignItems: 'center' }}>
                    <span>{experienceGroup?.[0]?.organization} - {experienceGroup?.[0]?.industry}</span>
                    {/* {(hasFieldPending(experienceGroup?.[0], 'organization') || hasFieldPending(experienceGroup?.[0], 'industry')) && <PendingIcon />} */}
                  </SecondaryHeadingNew>
                  <GreyText color={COLORS.GREY_T_60}>
                    {DateDiffArray(experienceGroup)}
                  </GreyText>
                  <Steps
                    key={groupIndex + "experience"}
                    current={-1}  // Set current to -1 to hide the active step
                    direction="vertical"
                    progressDot={(dot, { index, status }) => {
                      const dotStyle = {
                        width: '9px',
                        height: '9px',
                        borderRadius: '50%',  // Make it a circle
                        background: '#D9D9D9',
                      };

                      return (
                        <div style={dotStyle}>
                          {dot}
                        </div>
                      );
                    }}
                    items={experienceGroup.map((expItem) => ({
                      title: (
                        <SubFLex gap="10px" flexStart key={expItem?.id} style={{ paddingTop: '7px' }}>
                          <SecondaryHeading fontWeight="600" style={{ wordBreak: 'break-word', overflowWrap: 'anywhere' }}>
                            {expItem?.title}
                          </SecondaryHeading>
                          {(expItem?._requestId || expItem?._pendingFields) && (
                            <CustomTag
                              message="Need Approval"
                              bordered={true}
                              background={'#eb5d60'}
                              border={'#eb5d60'}
                              color={'#fff'}
                            />
                          )}
                          {expItem?.jobType == "FULL_TIME" ?
                            <CustomTag
                              message={"Full Time"}
                              border='#CCCFD6'
                              bordered={true}
                              background='#F2F3F5'
                              colorType="#808697"
                            />
                            :
                            <CustomTag
                              message={"Part Time"}
                              border='#CCCFD6'
                              bordered={true}
                              background='#F2F3F5'
                              colorType="#808697"
                            />
                          }
                        </SubFLex>
                      ),
                      description: (
                        <>
                          {(expItem?.started_in || expItem?.ended_in) && (expItem?.isCurrentlyWorking ?
                            <GreyText color={"#3249D7"}>
                              {moment(expItem?.started_in, 'MM/YYYY')?.format('MMM YYYY')} -{' '}
                              {expItem?.isCurrentlyWorking
                                ? 'Present'
                                : moment(expItem?.ended_in, 'MM/YYYY')?.format('MMM YYYY')}
                              {' '}
                              {expItem?.isCurrentlyWorking
                                ? `(${DateDiff(expItem?.started_in, undefined)})`
                                : `(${DateDiff(expItem?.started_in, expItem?.ended_in)})`}
                            </GreyText> :
                            <GreyText color={COLORS.GREY_T_60}>
                              {moment(expItem?.started_in, 'MM/YYYY')?.format('MMM YYYY')} -{' '}
                              {expItem?.isCurrentlyWorking
                                ? 'Present'
                                : moment(expItem?.ended_in, 'MM/YYYY')?.format('MMM YYYY')}
                              {' '}
                              {expItem?.isCurrentlyWorking
                                ? `(${DateDiff(expItem?.started_in, undefined)})`
                                : `(${DateDiff(expItem?.started_in, expItem?.ended_in)})`}
                            </GreyText>)}
                          {expItem?.skill_set?.length > 0 &&
                            <SecondaryHeading fontWeight="600">
                              Skills
                            </SecondaryHeading>}
                          {/* Additional details like skills, function, role, etc. can be added here */}
                          <SubFLex centerVertically gap="5px" marginBottom="15px" wrap>
                            {expItem?.skill_set?.map((value, key) => (
                              <CustomTag
                                message={value?.name}
                                bordered={true}
                                background={'#F2F3F5'}
                                border={'#F2F3F5'}
                                key={key + "skillSet"}
                              />
                            ))}
                          </SubFLex>
                           {expItem?.certificate && Object.keys(expItem?.certificate).length > 0 && (
                              <FileReaderVisibleOnly file={expItem?.certificate} />
                            )}
                          <Flex centerVertically>
                            {/* {expItem?.function &&
                              <>
                                <NameAdd1 column flexStart>
                                  <TextLight1 color={COLORS.GREY_T_20}>Function</TextLight1>
                                  <BoldTextDate color={COLORS.GREY_T_20} style={{ wordBreak: 'break-word', overflowWrap: 'anywhere', display: 'flex', alignItems: 'center' }}>
                                    <span>{expItem?.function}</span>
                                    {hasFieldPending(expItem, 'function') && <PendingIcon />}
                                  </BoldTextDate>
                                </NameAdd1>
                                {expItem?.role && <VerticalDivider type="vertical" />}
                              </>
                            } */}
                            {expItem?.role &&
                              <>
                                <NameAdd1 column flexStart>
                                  <TextLight1 color={COLORS.GREY_T_20}>Role</TextLight1>
                                  <BoldTextDate color={COLORS.GREY_T_20} style={{ wordBreak: 'break-word', overflowWrap: 'anywhere', display: 'flex', alignItems: 'center' }}  >
                                    <span>{expItem?.role}</span>
                                    {/* {hasFieldPending(expItem, 'role') && <PendingIcon />} */}
                                  </BoldTextDate>
                                </NameAdd1>
                                {expItem?.industry && <VerticalDivider type="vertical" />}
                              </>
                            }
                            {expItem?.industry &&
                              <NameAdd1 column flexStart>
                                <TextLight1 color={COLORS.GREY_T_20}>Industry</TextLight1>
                                <BoldTextDate color={COLORS.GREY_T_20} style={{ wordBreak: 'break-word', overflowWrap: 'anywhere' }}>
                                  {expItem?.industry}
                                </BoldTextDate>
                              </NameAdd1>
                            }
                          </Flex>
                          {countRichTextCharacters(expItem?.description) > 0 ?
                            <StyledP>
                              <EditorContent
                                dangerouslySetInnerHTML={{
                                  __html: expItem?.description || '',
                                }}
                              />
                            </StyledP>
                            : null}
                          {expItem?.certificate && Object.keys(expItem?.certificate).length > 0 && (
                            <>
                              {hasFieldPending(expItem, 'certificate') || item._isNew ? (
                                <div
                                  style={{
                                    background: '#FFE5E6',
                                    padding: '12px 16px',
                                    borderRadius: '8px',
                                    display: 'flex',
                                    alignItems: 'center',
                                    justifyContent: 'space-between',
                                    marginTop: '8px',
                                    marginBottom: '8px'
                                  }}
                                >
                                  <span style={{ fontSize: '14px', color: '#1F2937' }}>
                                    Marksheet Submitted - <span style={{ color: '#3249D7', fontWeight: 500 }}>{expItem?.certificate?.name || 'Document.jpg'}</span>
                                  </span>
                                  <button
                                    onClick={() => {
                                      const newWindow = window.open(expItem?.certificate?.url, '_blank', 'noopener,noreferrer')
                                      if (newWindow) newWindow.opener = null
                                    }}
                                    style={{
                                      background: '#3249D7',
                                      color: '#fff',
                                      border: 'none',
                                      borderRadius: '6px',
                                      padding: '6px 20px',
                                      fontSize: '14px',
                                      fontWeight: 500,
                                      cursor: 'pointer'
                                    }}
                                  >
                                    View
                                  </button>
                                </div>
                              ) : (
                                <FileReaderVisibleOnly file={expItem?.certificate} />
                              )}
                            </>
                          )}
                          {expItem?.awards?.length > 0 && (
                            <>
                              <br></br>
                              <RewardTiteNew>Rewards and Recognition </RewardTiteNew>
                            </>
                          )}
                          {expItem?.awards?.map((value, key) => (
                            <SubFLex column gap="25px" marginBottom="10px" key={key + "award"}>
                              <SubFLex gap="12px">
                                <div>
                                  <Avatar
                                    background="none"
                                    src={''}
                                    size={48}
                                    icon={<AwardsIconWork />}
                                    boxShadow={true}
                                    padding="5px"
                                  />
                                </div>
                                <SubFLex column style={{ width: '90%' }}>
                                  <SecondaryHeading>{value?.title}</SecondaryHeading>
                                  <GreyText color={COLORS.GREY_T_60}>
                                    {moment(value?.awarded_on).format('DD MMM YYYY')}
                                  </GreyText>
                                  {countRichTextCharacters(value?.description) > 0 ?
                                    <StyledP>
                                      <EditorContent
                                        dangerouslySetInnerHTML={{
                                          __html: value?.description || '',
                                        }}
                                      />
                                    </StyledP>
                                    : null}
                                  {value?.certificate && (
                                    <FileReaderVisibleOnly file={value?.certificate} />
                                  )}
                                </SubFLex>
                              </SubFLex>
                            </SubFLex>
                          ))}
                        </>
                      ),
                    }))}
                  />
                </SubFLex>
              </SubFLex>

            ) :
              <>
                {experienceGroup?.map((expItem, index) => (

                  <SubFLex gap="12px" key={index + "experience"}>
                    <div>
                      <Avatar
                        background="none"
                        src={''}
                        size={48}
                        icon={<ApartmentIcon />}
                        boxShadow={true}
                        padding="5px"
                        shape="square"
                      />
                    </div>
                    <SubFLex column style={{ width: '90%' }}>
                      <Flex centerVertically gap="10px">
                        <div style={{ flex: 1 }}>
                          <SecondaryHeadingNew fontWeight="600" style={{ wordBreak: 'break-word', overflowWrap: 'anywhere' }}>
                            {experienceGroup?.[0]?.organization} - {experienceGroup?.[0]?.industry}
                          </SecondaryHeadingNew>
                        </div>
                        {(expItem?._requestId || expItem?._pendingFields) && (
                          <CustomTag
                            message="Need Approval"
                            bordered={true}
                            background={'#eb5d60'}
                            border={'#eb5d60'}
                            color={'#fff'}
                          />
                        )}
                      </Flex>
                      <GreyText color={COLORS.GREY_T_60}>
                        {expItem?.isCurrentlyWorking
                          ? DateDiff(expItem?.started_in, undefined)
                          : DateDiff(expItem?.started_in, expItem?.ended_in)}
                      </GreyText>
                      <SubFLex gap="10px" flexStart key={expItem?.id} style={{ paddingTop: '7px' }}>
                        <SecondaryHeading fontWeight="600" style={{ wordBreak: 'break-word', overflowWrap: 'anywhere' }}>
                          {expItem?.title}
                        </SecondaryHeading>
                        {expItem?.jobType == "FULL_TIME" ?
                          <CustomTag
                            message={"Full Time"}
                            border='#CCCFD6'
                            bordered={true}
                            background='#F2F3F5'
                            colorType="#808697"
                          />
                          :
                          <CustomTag
                            message={"Part Time"}
                            border='#CCCFD6'
                            bordered={true}
                            background='#F2F3F5'
                            colorType="#808697"
                          />
                        }
                      </SubFLex>

                      {(expItem?.started_in || expItem?.ended_in) && (expItem?.isCurrentlyWorking ?
                        <GreyText color={"#3249D7"}>
                          {moment(expItem?.started_in, 'MM/YYYY')?.format('MMM YYYY')} -{' '}
                          {expItem?.isCurrentlyWorking
                            ? 'Present'
                            : moment(expItem?.ended_in, 'MM/YYYY')?.format('MMM YYYY')}
                          {' '}
                          {expItem?.isCurrentlyWorking
                            ? `(${DateDiff(expItem?.started_in, undefined)})`
                            : `(${DateDiff(expItem?.started_in, expItem?.ended_in)})`}
                        </GreyText> :
                        <GreyText color={COLORS.GREY_T_60}>
                          {moment(expItem?.started_in, 'MM/YYYY')?.format('MMM YYYY')} -{' '}
                          {expItem?.isCurrentlyWorking
                            ? 'Present'
                            : moment(expItem?.ended_in, 'MM/YYYY')?.format('MMM YYYY')}
                          {' '}
                          {expItem?.isCurrentlyWorking
                            ? `(${DateDiff(expItem?.started_in, undefined)})`
                            : `(${DateDiff(expItem?.started_in, expItem?.ended_in)})`}
                        </GreyText>)}
                      {expItem?.skill_set?.length > 0 &&
                        <SecondaryHeading fontWeight="600">
                          Skills
                        </SecondaryHeading>}
                      <SubFLex centerVertically gap="5px" marginBottom="15px" wrap>
                        {expItem?.skill_set?.map((value, key) => (
                          <CustomTag
                            message={value?.name}
                            bordered={true}
                            background={'#F2F3F5'}
                            border={'#F2F3F5'}
                            key={key + "skillSet"}
                          />
                        ))}
                      </SubFLex>
                      <Flex centerVertically>
                        {/* <NameAdd1 column flexStart>
                          <TextLight1 color={COLORS.GREY_T_20}>Function</TextLight1>
                          <BoldTextDate color={COLORS.GREY_T_20} style={{ wordBreak: 'break-word', overflowWrap: 'anywhere', display: 'flex', alignItems: 'center' }}>
                            <span>{expItem?.function}</span>
                            {hasFieldPending(expItem, 'function') && <PendingIcon />}
                          </BoldTextDate>
                        </NameAdd1>
                        <VerticalDivider type="vertical" /> */}
                        <NameAdd1 column flexStart>
                          <TextLight1 color={COLORS.GREY_T_20}>Role</TextLight1>
                          <BoldTextDate color={COLORS.GREY_T_20} style={{ wordBreak: 'break-word', overflowWrap: 'anywhere', display: 'flex', alignItems: 'center' }}>
                            <span>{expItem?.role}</span>
                            {/* {hasFieldPending(expItem, 'role') && <PendingIcon />} */}
                          </BoldTextDate>
                        </NameAdd1>
                        <VerticalDivider type="vertical" />
                        <NameAdd1 column flexStart>
                          <TextLight1 color={COLORS.GREY_T_20}>Industry</TextLight1>
                          <BoldTextDate color={COLORS.GREY_T_20} style={{ wordBreak: 'break-word', overflowWrap: 'anywhere' }}>
                            {expItem?.industry}
                          </BoldTextDate>
                        </NameAdd1>
                        {/* <VerticalDivider type="vertical" />
                        <NameAdd1 column flexStart>
                          <TextLight1 color={COLORS.GREY_T_20}>Industry</TextLight1>
                          <BoldTextDate color={COLORS.GREY_T_20} style={{ wordBreak: 'break-word', overflowWrap: 'anywhere' }}>
                            {expItem?.industry}
                          </BoldTextDate>
                        </NameAdd1> */}
                      </Flex>
                      {countRichTextCharacters(expItem?.description) > 0 ?
                        <StyledP>
                          <EditorContent
                            dangerouslySetInnerHTML={{
                              __html: expItem?.description || '',
                            }}
                          />
                        </StyledP>
                        : null}
                      {expItem?.certificate && Object.keys(expItem?.certificate).length > 0 && (
                        <>
                          {hasFieldPending(expItem, 'certificate') || expItem?._isNew ? (
                            <div
                              style={{
                                background: '#FFE5E6',
                                padding: '12px 16px',
                                borderRadius: '8px',
                                display: 'flex',
                                alignItems: 'center',
                                justifyContent: 'space-between',
                                marginTop: '8px',
                                marginBottom: '8px'
                              }}
                            >
                              <span style={{ fontSize: '14px', color: '#1F2937' }}>
                                Marksheet Submitted - <span style={{ color: '#3249D7', fontWeight: 500 }}>{expItem?.certificate?.name || 'Document.jpg'}</span>
                              </span>
                              <button
                                onClick={() => {
                                  const newWindow = window.open(expItem?.certificate?.url, '_blank', 'noopener,noreferrer')
                                  if (newWindow) newWindow.opener = null
                                }}
                                style={{
                                  background: '#3249D7',
                                  color: '#fff',
                                  border: 'none',
                                  borderRadius: '6px',
                                  padding: '6px 20px',
                                  fontSize: '14px',
                                  fontWeight: 500,
                                  cursor: 'pointer'
                                }}
                              >
                                View
                              </button>
                            </div>
                          ) : (
                            <FileReaderVisibleOnly file={expItem?.certificate} />
                          )}
                        </>
                      )}
                      {expItem?.awards?.length > 0 && (
                        <>
                          <br></br>
                          <RewardTiteNew>Rewards and Recognition </RewardTiteNew>
                        </>
                      )}

                      {expItem?.awards?.map((value, key) => (
                        <SubFLex column gap="25px" marginBottom="10px" key={key + "award"}>
                          <SubFLex gap="12px">
                            <div>
                              <Avatar
                                background="none"
                                src={''}
                                size={48}
                                icon={<AwardsIconWork />}
                                boxShadow={true}
                                padding="5px"
                              />
                            </div>
                            <SubFLex column style={{ width: '90%' }}>
                              <SecondaryHeading>{value?.title}</SecondaryHeading>
                              <GreyText color={COLORS.GREY_T_60}>
                                {moment(value?.awarded_on).format('DD MMM YYYY')}
                              </GreyText>
                              {countRichTextCharacters(value?.description) > 0 ?
                                <StyledP>
                                  <EditorContent
                                    dangerouslySetInnerHTML={{
                                      __html: value?.description || '',
                                    }}
                                  />
                                </StyledP>
                                : null}
                              {value?.certificate && (
                                <FileReaderVisibleOnly file={value?.certificate} />
                              )}
                            </SubFLex>
                          </SubFLex>
                        </SubFLex>
                      ))}
                    </SubFLex>
                  </SubFLex>

                ))}
              </>
            }
          </>
        ))}
      </SubFLex>
    </>
  )

}

export default WorkExpSection